import { render, staticRenderFns } from "./info-label.vue?vue&type=template&id=72a1910d&"
import script from "./info-label.vue?vue&type=script&lang=js&"
export * from "./info-label.vue?vue&type=script&lang=js&"
import style0 from "./info-label.vue?vue&type=style&index=0&lang=scss&module=true&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports